import { render, staticRenderFns } from "./RegistrationList.vue?vue&type=template&id=2fe5b911&"
import script from "./RegistrationList.vue?vue&type=script&lang=js&"
export * from "./RegistrationList.vue?vue&type=script&lang=js&"
import style1 from "./RegistrationList.vue?vue&type=style&index=1&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QSelect,QInput,QIcon,QBtn,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QSelect,QInput,QIcon,QBtn,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd})
